import type { Slide } from '@features/powerpoint';
import { howWeDoItSlideV2 as baseSlide } from '@features/lci-report/slides/appendix/how-we-do-it-slide-v2';

export const howWeDoItSlideV2 = (): Slide => baseSlide();
